import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { getUserSession } from "../../../core/util/core/Session";

function Form() {
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const session = getUserSession();

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/revenues-document-types/save`,
        endpointGetById: `${endpointBackend}gci/revenues-document-types/getById`,
        urlGoBack: `/gci/revenues-document-types/list`,
        pathView: `/gci/revenues-document-types/view`
    }

    const labels = {
        labelTitleAdd: "Novo Tipo de Documento de Receita",
        labelTitleEdit: "Editar Tipo de Documento de Receita",
        labelTitleView: 'Visualizar Tipo de Documento de Receita'
    }

    const getForm = (values) => {

        let form = {
            fields: [
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'need_document_number',
                    type: 'checkbox',
                    label: 'Obrigatório de número do documento',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels,
        }

        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}

export default Form;
